"use client";

// src/stack.tsx
import * as React from "react";
import {
  systemForwardRef,
  Base
} from "@stepstone-genesis/system";
import { isArray } from "@stepstone-genesis/utilities";
import { Flex } from "@stepstone-genesis/components-flex";
import { useUIDSeed } from "@stepstone-genesis/uid-library";
var flexMap = {
  flexDirection: {
    horizontal: "row",
    vertical: "column"
  },
  flexWrap: {
    horizontal: "wrap",
    vertical: "nowrap"
  }
};
var formatDirection = (direction) => {
  const formattedDirection = isArray(direction) ? direction.map((dir) => dir && flexMap["flexDirection"][dir]) : (
    // @ts-ignore
    // direction is not null
    flexMap["flexDirection"][direction]
  );
  return formattedDirection;
};
var formatWrap = (direction) => {
  const formattedWrap = isArray(direction) ? direction.map((dir) => dir && flexMap["flexWrap"][dir]) : (
    // @ts-ignore
    // direction is not null
    flexMap["flexWrap"][direction]
  );
  return formattedWrap;
};
var formatStyles = (direction, spacing) => {
  if (isArray(direction)) {
    const mr = [];
    const mb = [];
    direction.forEach((value, i) => {
      mr[i] = value === "horizontal" ? isArray(spacing) ? spacing[i] || [] : spacing : "spaceNone";
      mb[i] = value === "horizontal" ? "spaceNone" : isArray(spacing) ? spacing[i] || [] : spacing;
    });
    return { mr, mb };
  }
  const singleDirectionStyles = direction === "horizontal" ? { mr: spacing } : { mb: spacing };
  return singleDirectionStyles;
};
var checkValidChildren = (children) => {
  const validChildren = React.Children.toArray(children).filter(
    (child) => React.isValidElement(child) || typeof child === "string"
  );
  return [validChildren];
};
var Stack = systemForwardRef(function Stack2({
  direction = "horizontal",
  spacing = "spaceM",
  wrapChildElement = true,
  children,
  ...rest
}, ref) {
  const [styles, formattedDirection, formattedWrap] = React.useMemo(() => {
    const formattedDirection2 = formatDirection(direction);
    const formattedWrap2 = formatWrap(direction);
    const styling = formatStyles(direction, spacing);
    return [styling, formattedDirection2, formattedWrap2];
  }, [direction, spacing]);
  const [validChildren] = React.useMemo(
    () => checkValidChildren(children),
    [children]
  );
  const idSeed = useUIDSeed();
  return /* @__PURE__ */ React.createElement(
    Flex,
    {
      ref,
      flxDirection: formattedDirection,
      flxWrap: formattedWrap,
      ...rest
    },
    validChildren.map((child, index) => {
      const isLastChild = validChildren.length === index + 1;
      return /* @__PURE__ */ React.createElement(React.Fragment, { key: idSeed(`stack-${index}`) }, wrapChildElement && /* @__PURE__ */ React.createElement(Base, { ...!isLastChild ? styles : null }, child), !wrapChildElement && React.isValidElement(child) && React.cloneElement(child, {
        ...child.props,
        ...!isLastChild ? styles : null,
        ...!isLastChild && child.props.sx ? { sx: { ...styles, ...child.props.sx } } : {}
      }));
    })
  );
});
export {
  Stack
};
